<template>
  <DaiTarjetaContenedorMapa
    class="fix"
    :es-version-escritorio-en-pantalla-larga="true"
    altura-colapsada="650px"
    etiqueta-colapso="Más información"
    etiqueta-no-colapso="Menos información"
  >
    <Loader v-if="!(this.estadosCargados && this.cultivosCargados)" />

    <template #header>
      <h3 v-width-control="'100%'">Principales cultivos con uso significativo de glifosato 2019</h3>
      <p>Se muestran los diez municipios de nueve entidades con mayor superficie para los siguientes cultivos:</p>
    </template>

    <DaiMapa ref="mapa"
      class="canvas-container-mapa"
      :extension="[-118.365119934082,14.5320978164673,-86.7104034423828,32.7186546325684]"
    >
      <DaiCapaXyz />

      <DaiCapaGeojson 
        url="data/mapa-cultivos/estados.geojson"
        :estilo-capa="{
          fill: {color: 'transparent'},
          stroke: {color: 'green', width: 1}
        }"
        :estilo-realce="{
          stroke: {color: 'green', width: 3}
        }"
        @click_feature="clickEstado"
        @saved_features="estadosCargados = true"
      />

      <DaiCapaGeojson 
        id="capa_cultivos"
        url="data/mapa-cultivos/cultivos.geojson"
        :reglas-estilo-capa="[
          {
            clasificacion: 'categorias',
            columna: 'cultivo',
            propiedadObjetivo: 'relleno',
            colores: ['#21D170d1','#896376d1','#9E0A57d1','#84722Fd1','#FDF435d1','#DD601Bd1','#84360Bd1','#FEA875d1','#096330d1'],
            acomodoCategorias: ['Aguacate','Algodón hueso','Café cereza','Caña de azúcar','Maíz grano','Naranja','Sorgo','Soya','Tomate']
          },
          {
            clasificacion: 'personalizada',
            propiedadObjetivo: 'proporcion',
            columna: 'cultivo_tot',
            clasificacionPersonalizada: [[1,10000],[10000,40000],[40000,100000],[100000,217000]],
            proporciones: [4,8,12,16],
            clases: 4,
            tituloVariable: 'Hectáreas de cultivos'
          }
        ]"
        :contenidoTooltip="(feature)=> { 
          return `<strong>${feature.nom_mun}, ${estados[feature.cve_ent].abre}</strong><br>
          <span class='indicador-tooltip' style='background-color:${diccionarioCultivos[feature.cultivo].color}'></span> 
          ${diccionarioCultivos[feature.cultivo].title}<br>${Number(feature.cultivo_tot).toLocaleString()} hectáreas`
        }"
        @saved_features="redimensionarMapa"
      />
    </DaiMapa>

    <template #footer>
      <!-- Dado que el componente no cuenta con esta curva, actualmente la version de daimaps es v0.1.13, 
      si se actualiza la version de dai-maps se debe revisar si ya lo trae, 
      ya que podria encimarce con esta que esta adecuada solo para este proyecto
      -->
      <div class="curva-flotante">
        <div></div>
      </div>

      <DaiLeyendaMapa class="leyenda-reverse"
        para="capa_cultivos"
        :mostrar-boton-alterna-todos="true"
        titulo="Cultivos"
      />

      <hr class="dai-map-separator thin">
      
      <div class="dai-map-notes">
        <p>
          Muestra el número de hectáreas por municipio de los cultivos más representativos con uso de glifosato como herbicida en nueve entidades.
        </p>
        <p>
          <b>Fuente:</b> Servicio de Información Agroalimentaria y Pesquera 2019. Tabulado procesado por el grupo de trabajo Conahcyt-Alternativas al Glifosato.
        </p>
      </div>

      <hr class="dai-map-separator thin">
      <a class="dai-map-button download" :href="`${cdnArchivos}/cultivos_glifosato.zip`" download>
        Descargar datos
      </a>
    </template>
  </DaiTarjetaContenedorMapa>
</template>

<script>
import estados from '../_diccionario_estados.json'
import diccionarioCultivos from '../_diccionario_cultivos.json'
import Loader from '@/components/utiles/Loader.vue'

export default {
  name: "MapaPrincipalesCultivos",
  data() { return {
    estados: estados,
    diccionarioCultivos: diccionarioCultivos,
    estadosCargados: false,
    cultivosCargados: false,
    cdnArchivos:  `${process.env.VUE_APP_CDN_ARCHIVOS}/impactos`,
  }},
  methods:{
    clickEstado() {},
    redimensionarMapa(){
      this.$refs.mapa.forceResizeMap(true)
      this.cultivosCargados = true
    },
  },
  components: {
    Loader,
  },
}
</script>

<style lang="scss">
.fix {
  overflow: hidden;
}
.dai-map-notes{
  font-size: 11px;
  padding-top: 1em;
}

.canvas-container-mapa{
  height: 35vh;
  
}

.card-map-container{
  .dai-map-container{
    margin-left: -.3rem;
    margin-right: -.3rem;
  }

  .curva-flotante{
    @media screen and (min-width: 976px){
      display: none;
    }
    position: relative;
    background-color: rgb(255, 152, 152);
    border-radius: 10px;
    height: 0px;
    width: 100%;
    margin: 0 !important;
    >div{
      position: absolute;
      background-color: white;
      border-radius: 10px;
      top: calc(-.5rem - 6px);
      left: -.3rem;
      width: calc(100% + .9rem);
      height: 14px;
      box-shadow: 0px -2px 2px 0px #80808069;
    }
  }
}
</style>